// Constants
// ---------
// This list contains all available constants referenced in the 'bonus' commands.
// export const BonusParam = `
// // * Trigger criteria (bf)
// const BF_SHORT = 0 //= Trigger on melee attacks
// const BF_LONG = 1 //= Trigger on ranged attacks
// // (Default: BF_SHORT+BF_LONG)

// const BF_WEAPON = 0 //= Trigger on weapon skills
// const BF_MAGIC = 1 //= Trigger on magic skills
// const BF_MISC = 2 //= Trigger on misc skills
// // (Default: BF_WEAPON)

// const BF_NORMAL = 0 //= Trigger on normal attacks
// const BF_SKILL = 1 //= Trigger on skills
// // (Default: BF_SKILL if type is BF_MISC or BF_MAGIC, BF_NORMAL if type is BF_WEAPON)

// // * Trigger criteria (atf)
// // Effect target: (Default: Attacked target)
// const ATF_SELF = 0x01 //= Trigger effect on self
// const ATF_TARGET = 0x02 //= Trigger effect on target

// // Attack range criteria: (Default: All attacks)
// const ATF_SHORT = 0x04 //= Trigger on melee attacks
// const ATF_LONG = 0x08 //= Trigger on ranged attacks

// // Skill/attack type criteria: (Default: Physical/weapon)
// const ATF_SKILL = 0x20 | 0x40 //= Trigger on magic/misc skills
// const ATF_WEAPON = 0x10 //= Trigger on weapon skill / physical attacks
// const ATF_MAGIC = 0x20 //= Trigger on magic skills
// const ATF_MISC = 0x40 //= Trigger on misc skills

// // let val = 0
// `

export const BonusVariables = `
	let a = 0
	let b = 0
	let c = 0
	let d = 0
	let e = 0
	let f = 0
	let g = 0
	let i = 0
	let j = 0
	let l = 0
	let m = 0
	let n = 0
	let p = 0
	let r = 0
	let r2 = 0
	let r3 = 0
	let s = 0
	let t = 0
	let v = 0
	let M = 0
	let F = 0
	let S = 0
	let D = 0
	let E = 0

	let tmp = 0
	let view = 0
	let rate = 0
	let per = 0
	let lvl = 0
	let lv = 0
	let bblvl = 0
	let bon = 0
	let bon1 = 0
	let bon2 = 0
	let Class = 0
	let duration = 0
	let atk = 0
	let matk = 0
	let dmg = 0
	let sub = 0
	let delay = 0
	let aspd = 0
	let def = 0
	let mdef = 0
	let flee = 0
	let flee2 = 0
	let pd = 0
	let val = 0
	let red = 0
	let level = 0
	let chance = 0
	let crit = 0
	let type = 0
	let BaseLevel = baseLevel
	let JobLevel = jobLevel
	let slv = 0
	//MERCHANT | EAJL_2_1 | EAJL_THIRD
	let EAJ_MECHANIC = 0x5 | 0x100 | 0x4000
	//ARCHER | EAJL_2_2 | EAJL_THIRD
	let EAJ_MINSTRELWANDERER = 0x3 | 0x200 | 0x4000
	//MAGE | EAJL_2_1 | EAJL_THIRD
	let EAJ_WARLOCK = 0x2 | 0x100 | 0x4000

	let varskill = 0
	let lvll = 0
	let hp = 0
	let sp = 0
	let hpsp = 0
	let stats = 0
	let param = 0
	//variables declarations for combos 
	let eq = 0
	let weapon = 0
	let head = 0
	let r_top = 0
	let r_weapon = 0
	let r_shield = 0
	let r_armor = 0
	let r_garment = 0
	let r_shoes = 0
	let r_right = 0
	let r_left = 0
	let r0 = 0
	let r1 = 0
	// let r2 = 0
	let r_2198 = 0
	let r_1649 = 0
	let shoes = 0
	let garment = 0
	let skill_level = 0
	let time = 0
	let recovery = 0
	let crit_dmg = 0
	let sub_player = 0
	
	let sum = 0

	let ENCHANTGRADE_A = "A"
	let ENCHANTGRADE_B = "B"
	let ENCHANTGRADE_C = "C"
	let ENCHANTGRADE_D = "D"
	let ENCHANTGRADE_E = "E"
	
	//
	let str = 0
	let agi = 0
	let vit = 0
	let int = 0
	let dex = 0
	let luk = 0
	let bStr = baseSTR
	let bAgi = baseAGI
	let bVit = baseVIT
	let bInt = baseINT
	let bDex = baseDEX
	let bLuk = baseLUK
	let bPow = basePOW
	let bSta = baseSTA
	let bWis = baseWIS
	let bSpl = baseSPL
	let bCon = baseCON
	let bCrt = baseCRT
	let cast = 0
	let cri = 0
	let criatk = 0
	let critical = 0
	let critical_dmg = 0
	let sub_arrowstorm = 0
	let sub_gateofhell = 0
	let MaxHp = 0
	let MaxSp = 0
	let drop = 0
	let EAJL_UPPER = 0x1000
	let EAJL_THIRD = 0x4000
	//remove rebirth, baby and 4th class flags
	let EAJ_THIRDMASK = ~0x1000 & ~0x2000 & ~0x8000
	// let EAJ_UPPERMASK = 0;
	let EQI_HEAD_TOP = inventory['Head_Top']
	let EQI_HEAD_MID = inventory['Head_Mid']
	let EQI_HEAD_LOW = inventory['Head_Low']
	let EQI_ARMOR = inventory['Armor']
	let EQI_HAND_R = inventory['Right_Hand']
	let EQI_HAND_L = inventory['Left_Hand']
	let EQI_GARMENT = inventory['Garment']
	let EQI_SHOES = inventory['Shoes']
	let EQI_ACC_R = inventory['Right_Accessory']
	let EQI_ACC_L = inventory['Left_Accessory']
	
	let EQI_SHADOW_WEAPON = inventory['Shadow_Weapon']
	let EQI_SHADOW_SHIELD = inventory['Shadow_Shield']
	let EQI_SHADOW_ACC_SHIELD = inventory['Shadow_Shield']
	let EQI_SHADOW_ARMOR = inventory['Shadow_Armor']
	let EQI_SHADOW_ACC_ARMOR  = inventory['Shadow_Armor']
	let EQI_SHADOW_SHOES = inventory['Shadow_Shoes']
	let EQI_SHADOW_ACC_SHOES = inventory['Shadow_Shoes']
	let EQI_SHADOW_ACC_R = inventory['Shadow_Right_Accessory']
	let EQI_SHADOW_ACC_L = inventory['Shadow_Left_Accessory']
	let EQI_COMPOUND_ON = equip

	let W_BOW = "Bow"
	let W_BOOK = "Book"
	let W_STAFF  = "Staff"
	let W_2HSTAFF = "2hStaff"
	let W_DAGGER = "Dagger"
	let W_REVOLVER = "Revolver"
	let W_2HAXE = "2HAxe"
	let W_1HAXE = "1HAxe"
	let W_MACE = "Mace"
	let W_1HSWORD = "1hSword"
	let W_2HSWORD = "2hSword"
	let W_MUSICAL = "Musical"
	let W_WHIP = "Whip"
	let W_1HSPEAR = "1HSpear"
	let W_2HSPEAR = "2HSpear"
	let W_KNUCKLE = "Knuckle"
	let W_KATAR  = "Katar"
	let W_HUUMA   = "Huuma"
	let W_RIFLE   = "Rifle"
	let W_GATLING   = "Gatling"
	let W_SHOTGUN   = "Shotgun"
	let W_GRENADE   = "Grenade"
	let Upper = 0
	let ITEMINFO_VIEW = 11
	//random number , need to fing the good one
	let ITEMINFO_WEAPONLEVEL  = 12
	let ITEMINFO_ARMORLEVEL   = 13
	let heal = 0
	let BaseClass = 0
	let BaseJob = getBaseJob(job)
	let vip_status = () => {return 0}
	let VIP_STATUS_ACTIVE  =0
	let factor = 0
	let PET_INTIMATE_LOYAL = 0

	let EQP_ACC_R = "Right_Accessory"
	let EQP_ACC_L = "Left_Accessory"
	let EQP_HAND_L = "Left_Hand"
`
